import fs from 'node:fs'
import path from 'node:path'

export function listSchemaNames(schemasDir: string): string[] {
  if (!fs.existsSync(schemasDir)) return []

  const names = new Set<string>()
  const rootFiles = fs
    .readdirSync(schemasDir)
    .filter((f) => f.endsWith('.json') && f !== 'schema.json')
    .map((f) => f.replace('.json', ''))

  for (const name of rootFiles) {
    names.add(name)
  }

  const formsDir = path.join(schemasDir, 'forms')
  if (fs.existsSync(formsDir)) {
    for (const name of fs
      .readdirSync(formsDir)
      .filter((f) => f.endsWith('.json'))
      .map((f) => f.replace('.json', ''))) {
      names.add(name)
    }
  }

  return Array.from(names).sort()
}
